import React from "react";
import { Form, Button, Dropdown } from "react-bootstrap";

// export const TimeRange = "3m" | "6m" | "12m" | "24m" | "all";
// export const TypeFilter = "all";

/**
 * @typedef {Object} MembershipFilterBarProps
 * @property {string} range
 * @property {(s: string) => void} setRange
 * @property {string} type
 * @property {(c: string) => void} setType
 * @property {string} status
 * @property {(c: string) => void} setStatus
 * @property {string[]} types
 * @property {string[]} statusList
 * @property {() => void} onRefresh
 * @property {string} report
 */

/**
 * @param {MembershipFilterBarProps} props
 */

export function MembershipFilterBar({
  range,
  setRange,
  type,
  setType,
  status,
  setStatus,
  types,
  statusList,
  onRefresh,
  report,
}) {
  return (
    <div className="pbi-filterbar">
      <div className="d-flex align-items-center gap-2 flex-wrap">
        <i className="bi bi-funnel-fill text-primary" />
        <span className="fw-semibold me-2">Filters</span>

        {/* <ButtonGroup size="sm">
          {["12m", "12 Quarters", "5 Years"].map((r) => (
            <Button
              key={r}
              variant={range === r ? "primary" : "outline-secondary"}
              onClick={() => setRange(r)}
            >
              {r === "all" ? "All time" : `Last ${r.replace("m", "mo")}`}
            </Button>
          ))}
        </ButtonGroup> */}

        {/* {report === "revenue" ? (
          <ButtonGroup size="sm">
            {["12m", "12 Quarters", "5 Years"].map((r) => (
              <Button
                key={r}
                variant={range === r ? "primary" : "outline-secondary"}
                onClick={() => setRange(r)}
              >
                {r === "all" ? "All time" : `Last ${r.replace("m", "mo")}`}
              </Button>
            ))}
          </ButtonGroup>
        ) : (
          // <ButtonGroup size="sm">
          //   {["all"].map((r) => (
          //     <Button
          //       key={r}
          //       variant={range === r ? "primary" : "outline-secondary"}
          //       onClick={() => setRange(r)}
          //     >
          //       {r === "all" ? "All time" : `Last ${r.replace("m", "mo")}`}
          //     </Button>
          //   ))}
          // </ButtonGroup>
          <></>
        )} */}

        <Dropdown>
          <Dropdown.Toggle size="sm" variant="outline-secondary">
            <i className="bi bi-collection me-1" />
            {type === "all" ? "All types" : type}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item onClick={() => setType("all")}>
              All types
            </Dropdown.Item>
            <Dropdown.Divider />
            {types.map((t) => (
              <Dropdown.Item key={t} onClick={() => setType(t)}>
                {t}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>

        <Form.Select
          size="sm"
          style={{ width: 140 }}
          value={status}
          onChange={(e) =>
            setStatus(e.target.value /* as "all" | "Active" | "Inactive" */)
          }
        >
          <option value="all">All members</option>
          {(statusList ?? []).map((t, i) => (
            <option value={t} key={i}>
              {t}
            </option>
          ))}

          {/* <option value="Active">Active only</option>
          <option value="Inactive">Inactive only</option> */}
        </Form.Select>
      </div>

      <div className="d-flex align-items-center gap-2">
        <Button size="sm" variant="outline-secondary" onClick={onRefresh}>
          <i className="bi bi-arrow-clockwise" />
        </Button>
        <Button size="sm" variant="outline-secondary">
          <i className="bi bi-download me-1" />
          Export
        </Button>
      </div>
    </div>
  );
}
